export const AdminSelection = Object.freeze({
    "SelfEnrollment": 1,
    "OnBehalfOfEmployee": 1,
    "ReviewPendingEnrollments": 2
})